<template>
  <div>
    <div class="center-t">
      <div class="sp-odt">自主商标品牌建设情况管理</div>
    </div>
    <div class="page-wrap">
      <el-button
        icon="el-icon-plus"
        type="primary"
        size="mini"
        style="margin-bottom:20px"
        @click="handleAdd"
      >添加</el-button>
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column type="index" width="55" label="序号" align="center">
          <template slot-scope="scope">
            {{ (queryParams.pageNum - 1) * queryParams.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="brandName"
          label="品牌名称"
          width="200"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="trademarkNumber"
          label="主商标号"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="revenue"
          label="产值(万元)"
          align="center"
          width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="120">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.row.id)"
            >更新</el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-delete"
              @click="handleDelete(scope.row.id)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>
    <brandDialog
      :brand_dialogVisible.sync="brand_dialogVisible"
      v-if="brand_dialogVisible"
      :id="id"
      @refresh="getList"
    ></brandDialog>
  </div>
</template>
<script>
import { brandList, brandDelete } from "@/api/index";
import brandDialog from "@/views/userpage/components/brandDialog";
export default {
  components: { brandDialog },
  data() {
    return {
      queryParams: {
        pageSize: 10,
        pageNum: 1
      },
      tableData: [],
      id: "",
      total: 0,
      brand_dialogVisible: false
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      brandList({ ...this.queryParams }).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.total;
      });
    },
    handleEdit(id) {
      this.id = id;
      this.brand_dialogVisible = true;
    },
    handleAdd() {
      this.id = "";
      this.brand_dialogVisible = true;
    },
    handleDelete(id) {
      this.$confirm("是否确认删除该数据？", "提示", {
        confirmButtonText: "确定删除",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          brandDelete([id]).then(res => {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.getList();
          });
        })
        .catch(err => {});
    }
  }
};
</script>
<style lang="less" scoped>
</style>